import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Form, Col, Row, Input, Button } from 'antd';
import Spin from 'src/components/common/Spin';
import { FormComponentProps } from 'antd/lib/form';
import { ProxyCredential } from 'src/types/ProxyServiceInfo';
import { useFetchUserCredential } from 'src/api/proxyService';
import styles from './EditUserServiceForm.module.less';

type EditUserServiceFormProps = FormComponentProps & {
  onSave: (values: ProxyCredential) => void;
  proxyId: number;
};

const EditUserServiceForm: React.FC<EditUserServiceFormProps> = ({
  form,
  onSave,
  proxyId,
}: EditUserServiceFormProps) => {
  const { getFieldDecorator, getFieldsValue } = form;
  const [formFieldsSet, setFormFieldsSet] = useState(false);
  const [isFieldsTouched, setIsFieldsTouched] = useState(false);

  const { loading, userCredential } = useFetchUserCredential(proxyId);

  useEffect(() => {
    if (userCredential && !formFieldsSet) {
      if (userCredential.hasOwnProperty('userName') && userCredential.hasOwnProperty('password')) {
        form.setFieldsValue({
          userName: userCredential.userName,
          password: userCredential.password,
        });
        setFormFieldsSet(true);
      }
    }
  }, [userCredential, form, formFieldsSet, loading]);
  const handleFieldChange = () => {
    setIsFieldsTouched(true);
  };

  const disableSubmit = () => {
    return !isFieldsTouched || !getFieldsValue().userName || !getFieldsValue().password;
  };

  const handleSubmit = (event: SyntheticEvent): boolean => {
    event.preventDefault();
    form.validateFields((err, values: ProxyCredential) => {
      if (!err) {
        onSave({ ...values, proxyId });
      }
    });
    return false;
  };

  return (
    <div className={styles.userServiceFormWrapper}>
      <h1 className={styles.userServiceFromTitle}>Edit User Credential</h1>
      <Spin spinning={loading}>
        <Form layout="vertical" hideRequiredMark onSubmit={handleSubmit}>
          <div>
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item label={<h6 className={styles.fromLabel}>User Name:</h6>}>
                  {getFieldDecorator('userName', {
                    rules: [{ required: true, whitespace: true, message: 'User Name is required!' }],
                    validateTrigger: 'onBlur',
                  })(<Input type="text" placeholder="Please enter User Name" onChange={handleFieldChange} />)}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label={<h6 className={styles.fromLabel}>Password:</h6>}>
                  {getFieldDecorator('password', {
                    rules: [{ required: true, whitespace: true, message: 'Password is required!' }],
                    validateTrigger: 'onBlur',
                  })(<Input type="text" placeholder="Please enter Password" onChange={handleFieldChange} />)}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24} className={styles.serviceColumnButton}>
                <Col span={24}>
                  <Button
                    block
                    type="primary"
                    htmlType="submit"
                    disabled={disableSubmit()}
                    className={styles.saveButton}
                  >
                    Save
                  </Button>
                </Col>
              </Col>
            </Row>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

const WrappedEditUserServiceForm = Form.create<EditUserServiceFormProps>({ name: 'name' })(EditUserServiceForm);
export default WrappedEditUserServiceForm;
